import { render, staticRenderFns } from "./VariantInventory.vue?vue&type=template&id=47c52586"
import script from "./VariantInventory.vue?vue&type=script&lang=js"
export * from "./VariantInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports